import { render, staticRenderFns } from "./TechnologistOrderFormOrders.vue?vue&type=template&id=bf498550&scoped=true"
import script from "./TechnologistOrderFormOrders.vue?vue&type=script&lang=ts"
export * from "./TechnologistOrderFormOrders.vue?vue&type=script&lang=ts"
import style0 from "./TechnologistOrderFormOrders.vue?vue&type=style&index=0&id=bf498550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf498550",
  null
  
)

export default component.exports